<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">销假</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="form" :rules="rules" ref="form">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="请假时间">
                                    <el-date-picker
                                        v-model="startTime"
                                        type="datetime"
                                        style="width:100%;"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        disabled
                                        placeholder="请假时间">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="销假时间" required prop="reportTime">
                                    <el-date-picker
                                        v-model="form.reportTime"
                                        type="datetime"
                                        style="width:100%;"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        :picker-options="pickerOptions0"
                                        :default-value="new Date()"
                                        placeholder="销假时间">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="请假天数" required prop="dayNumber">
                                    <el-input v-model="form.dayNumber" type="number"  placeholder="请假天数"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="是否退费"   required prop="isRefund">
                                    <el-radio-group v-model="form.isRefund" style="width:100%" @change="isRefundChange">
                                        <el-radio :label='0'>不退</el-radio>
                                        <el-radio :label='1'>退</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row v-if="form.isRefund==1">
                            <el-col :span="12" class="item">
                                <el-form-item label="退费类型">
                                    <el-radio-group v-model="form.refundType" style="width:100%">
                                        <el-radio :label='1'>余额充值</el-radio>
                                        <el-radio :label='2'>现金退款</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="床位退费(元)">
                                    <el-input v-model="form.refundMoneyJson.room" type="number"  placeholder="床位费"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="护理退费(元)">
                                    <el-input v-model="form.refundMoneyJson.nursing" type="number"  placeholder="护理费"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="其他退费(元)">
                                    <el-input v-model="form.refundMoneyJson.other" type="number"  placeholder="其他费用"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('form')">销假</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Report',
        data() {
            return {
                loading: false,
                institutionValue:null,
                startTime:'',
                form:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    refundSettleCode:'',
                    reportTime:'',
                    dayNumber:'',
                    isRefund:0,
                    refundType:0,
                    refundMoneyJson:{
                        room:0,
                        nursing:0,
                        other:0
                    }
                },
                pickerOptions0: { 
                        disabledDate(time) {
                            return time.getTime() > Date.now();//如果没有后面的-8.64e7就是不可以选择今天的 
                        }
                },
                rules:{
                    reportTime:[
                        { required: true, message: '请选择销假时间', trigger: 'blur' },
                    ],
                    dayNumber:[
                        { required: true, message: '请输入请假天数', trigger: 'blur' },
                    ],
                    isRefund:[
                        { required: true, message: '请选择是否退费', trigger: 'blur' },
                    ],
                }
            }
        },

        methods: {
            init(value){
                this.form.refundSettleCode = value.refundSettleCode;
                this.startTime = value.startTime;
                this.$refs.form.resetFields();
                this.form.refundMoneyJson.room = 0;
                this.form.refundMoneyJson.nursing = 0;
                this.form.refundMoneyJson.other = 0;
            },
            closeSelf() {
                this.$emit("closeReport");
            },
            confirm(form){
                this.$refs[form].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },
            isRefundChange(val){
                if(val==1&&this.form.refundType==0){
                    this.form.refundType=1
                }
            },
            addSubmit(){
                if(this.form.dayNumber<=0){
                    this.$message("请假天数输入错误");
                    return;
                }
                if(this.form.isRefund==1){
                    let reg = /(^[0-9](\d+)?(\.\d{1,2})?$)|(^[1-9]$)|(^\d\.[1-9]{1,2}$)|(^\d\.[0]{1}[1-9]{1}$|(^\d\.[1-9]{1}[0]{1}$)$)/;
                    if(!reg.exec(this.form.refundMoneyJson.room)){
                        this.$message("床位退费不合法");
                        return;
                    }
                    if(!reg.exec(this.form.refundMoneyJson.nursing)){
                        this.$message("护理退费不合法");
                        return;
                    }
                    if(!reg.exec(this.form.refundMoneyJson.other)){
                        this.$message("其它退费不合法");
                        return;
                    }
                    if(this.form.refundMoneyJson.room<=0&&this.form.refundMoneyJson.nursing<=0&&this.form.refundMoneyJson.other<=0){
                        this.$message("至少需要输入一个退费项目价格");
                        return;
                    }
                }

                this.loading = true;
                
                this.form.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                if(this.form.isRefund==0)this.form.refundType=0
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"RefundSettle/Report",
                    data: this.form
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            if(this.form.isRefund==1){
                                this.$message("退费已提交审核");
                            }
                            this.$emit("closeReport");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 800px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
